<img src="/assets/icons/checkin_circle.svg"
     alt="{{'car.status.FREE' | translate}}"
     *ngIf="car?.status === FleetProfileStatus.FREE"/>
<img src="/assets/icons/checkout_circle.svg"
     alt="{{'car.status.IN_USE' | translate}}"
     *ngIf="car?.status === FleetProfileStatus.IN_USE"/>
